const React = require("react");
const T = React.PropTypes;

const SurveyType = require("~/types/Survey.js").PropType;
const UploadURL = require("~/config.js").UploadURL;

require("./SurveyConfirmationPage.less");

const SectionDispatchers = require("~/events/section/sectionDispatchers.js");
const QuestionValidationStatus = require("~/types/QuestionValidationStatus.js");
const SectionIsPositivelyValid = QuestionValidationStatus.SectionIsPositivelyValid;

const auditLoadDispatchers = require("~/events/auditLoad/auditLoadDispatchers.js");
const emailFetchDispatchers = require("~/events/emailFetch/emailFetchDispatchers.js");
const auditCompletionDispatchers = require("~/events/auditCompletion/auditCompletionDispatchers.js"); 

const MajorMessage = require("../MajorMessage/MajorMessage.jsx");
const MajorLoading = require("../MajorLoading/MajorLoading.jsx");
const SurveyLoadError = require("../SurveyLoadError/SurveyLoadError.jsx");

const Naviagtor = require("~/navigator.js");

const SurveyConfirmationPage = React.createClass({
    PropTypes: {
        Survey: SurveyType.isRequired,
        EmailRecipients: T.arrayOf(T.string),
        OnBack: T.func.isRequired,
        OnSubmit: T.func.isRequired,
        isComplete: T.bool.isRequired
    },
    componentWillMount() {
        if (this.props.Survey.Pages === null) {
            auditLoadDispatchers.LoadAudit(
                this.props.Survey.Type,
                this.props.Survey.FacilityNumber,
                this.props.Survey.GUID
                );
        }

        if (this.props.EmailRecipients === null) {
            emailFetchDispatchers.FetchEmail(
                this.props.Survey.FacilityNumber
                );
        }

        auditCompletionDispatchers.ScoreSample(this.props.Survey.Type, this.props.Survey.FacilityNumber, this.props.Survey.GUID);
    },
    componentWillReceiveProps(newProps) {
        if (!newProps.Survey.LoadError
            && !newProps.Survey.IsLoading) {
            if (this.props.Survey.GUID !== newProps.Survey.GUID) {
                auditLoadDispatchers.LoadAudit(
                    newProps.Survey.Type,
                    newProps.Survey.FacilityNumber,
                    newProps.Survey.GUID
                    );
            }
        }
    },
    render() {
        const list = this.GetList();
        let message = this.GetMessage();
        const emails = this.GetEmails();

        const pct = ((this.props.Survey.SampleScore / this.props.Survey.SampleMaxScore) * 100).toFixed(2);  

        if (message) {
            return (<MajorMessage>
                {message}
            </MajorMessage>);
        }

        return (<article>
            <div className="cs-SurveyConfirmationPage">
                {!this.props.isComplete && (
                    <div>
                        <p className="cs-SurveyConfirmationPage__label">
                            To continue, please complete the sections listed below.
                        </p>
                        {list}
                    </div>
                )}
                {this.props.isComplete && (
                <div>
                <p className="cs-SurveyConfirmationPage__label">
                    Thank you for completing the Audit!
                </p>
                <h2>
                    <b className="cs-SurveyFinalScore">Final Score | {this.props.Survey.SampleScore} / {this.props.Survey.SampleMaxScore} - {pct}% </b>
                </h2>
                <br />
                <p>
                    The Audit will be emailed to the following recipients upon clicking submit
                </p>

                    {emails}

                </div>)}
                <a className="cs-SurveyConfirmationPage__upload-link" href={UploadURL} target="_blank">
                    To upload file attachments, click here
                </a>
                <button onClick={this.props.OnBack}
                        className="btn btn-primary cs-SurveyConfirmationPage__btn">
                    Back
                </button>
                <button onClick={this.props.OnSubmit}
                        disabled={!this.props.isComplete}
                        className="btn btn-success cs-SurveyConfirmationPage__btn">
                    Submit
                </button>
            </div>
        </article>);
    },
    GetMessage() {
        if (this.props.Survey.LoadError) {
            return (<SurveyLoadError Error={this.props.Survey.LoadError } />);
        }

        if (this.props.Survey.IsLoading) {
            return (<MajorLoading />);
        }

        if (!(this.props.Survey.Pages || []).length) {
            return (<div>
                <h2>
                    This survey doesn't have any pages
                    <br />
                    for some strange reason.
                </h2>
                <h3>
                    Please contact Support Services.
                </h3>
            </div>);
        }
    },
    FindCurrentPage() {
        return this.props.Survey.Pages.find(p => p.GUID === this.props.Survey.CurrentPageGUID);
    },
    GetFilterer() {
        return (s) => !SectionIsPositivelyValid(s);
    },
    GetList() {
        if (!this.props.Survey.Pages) return null;

        const page = this.FindCurrentPage();
        const filterer = this.GetFilterer();

        const filteredSections = page.Sections
            .filter(filterer)
            .map(this.MakeSectionItem);

        const sections =
            filteredSections.length ?
            filteredSections :
            (<li className="cs-SurveyConfirmationPage__li__btn">None Found</li>)

        return (<div>
               <ol className="cs-SurveyConfirmationPage__ul__btn">
                   {sections}
               </ol>
        </div>);
    },
    MakeSectionItem(section, i) {
        return (<li className="cs-SurveyConfirmationPage__li__btn" key={i} onClick={this.GetSectionClickHandler(section)}>
                <span>{section.TitleHTML}</span>
        </li>)
    },
    GetSectionClickHandler(section) {
        return () => {
            Naviagtor.InCurrentPage.GoToSection(section.GUID);
        }

    },
    GetEmails() {
        if (!(this.props.EmailRecipients || []).length) {
            return (<div><p>Loading email recipients...</p></div>)
        }

        const emails = this.props.EmailRecipients.map((s, i) => {
            return (<li key={i} className="cs-SurveyConfirmationPage__li"><b>{s}</b></li>)
        });

        return (<div>
        <b>Email Recipients</b>
        <ul className="cs-SurveyConfirmationPage__ul">
            {emails}
        </ul>
        </div>)
    }
});


module.exports = SurveyConfirmationPage; 


// WEBPACK FOOTER //
// ./src/components/SurveyConfirmationPage/SurveyConfirmationPage.jsx